import ExpandCircleDown from "@mui/icons-material/ExpandCircleDown";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import { _, productDetailsPageUrl } from "common";
import modules from "modules";
import { useState } from "react";
import { FlexBox } from "./flex-box";
import { H4, H6, Small } from "./Typography";
import Link from "next/link";
import { LabelValue, TitleValue } from "modules/pcbuilder/types";

const { utils: pcBuilderUtils } = modules.pcBuilder;

interface Props {
  product_name?: string;
  product_uuid: string;
  parts_properties?: LabelValue[];
  productSlug?: string;
  custom_specs: TitleValue[];
  isScreenshot?: boolean;
}

export const BuildPartProperties = ({
  product_name,
  parts_properties,
  productSlug,
  product_uuid,
  isScreenshot = false,
  custom_specs = [],
}: Props) => {
  const [expandDetails, setExpandDetails] = useState(false);

  const {
    isEmptyPartsProperties,
    partsPropertiesFirst,
    partsPropertiesSecond,
  } = pcBuilderUtils.splitPartProperties(parts_properties, custom_specs);

  const onToggleViewDetails = () => {
    setExpandDetails((expand) => !expand);
  };

  return (
    <FlexBox flex={1} flexDirection="column">
      <Link
        passHref
        href={productDetailsPageUrl(productSlug, product_uuid)}
        key={`${productSlug}${product_uuid}`}
      >
        <a>
          <H4 fontWeight="700" fontSize={18}>
            {product_name}
          </H4>
        </a>
      </Link>

      <Collapse
        in={expandDetails || isScreenshot}
        collapsedSize={30}
        sx={{ marginTop: 1 }}
      >
        <Grid direction="row" container spacing={2}>
          <Grid item xs={6}>
            {_.map(partsPropertiesFirst, (item) => {
              return (
                <H6 fontWeight={700} fontSize={12} mt={1}>
                  {item?.label}
                  {": "}
                  <Small fontWeight={500}>{item.value}</Small>
                </H6>
              );
            })}
          </Grid>
          <Grid item xs={6}>
            {_.map(partsPropertiesSecond, (item) => {
              return (
                <H6 fontWeight={700} fontSize={12} mt={1}>
                  {item?.label}
                  {": "}
                  <Small fontWeight={500}>{item.value}</Small>
                </H6>
              );
            })}
          </Grid>
        </Grid>
      </Collapse>
      {isScreenshot || isEmptyPartsProperties ? null : (
        <Button
          color="secondary"
          disableRipple
          style={{
            height: 32,
            color: "black",
            alignSelf: "center",
            backgroundColor: "transparent",
          }}
          size="small"
          endIcon={<ExpandCircleDown />}
          onClick={onToggleViewDetails}
        >
          {expandDetails ? "View Less Details" : "View More Details"}
        </Button>
      )}
    </FlexBox>
  );
};
